<template>
    <DTHistory
    v-if="this.showHistory"
    :dataDT = "
      {
        nd: this.currentDT.nd,
        regnum: this.currentDT.regnum,
        statused: this.currentDT.statused,
        solutioncode: this.currentDT.solutioncode,
        edproc: this.currentDT.edproc,
        processid: this.currentDT.processid,        
        kodto: this.currentDT.kodto,
        fmtspec: this.currentDT.fmtspec,
      }
    "
    @closeWindow="this.showHistory = false"
  />
  <div class="list">
    <ul> 
      <ListDTRow v-for = "(dt, index) in currentPageDT"
        :key = index
        class="list__items"  
        :nd = "dt.nd"
        :declarant="dt.declarant"
        :regnum="dt.regnum"
        :statused="dt.statused"
        :lastmsgdate="dt.lastmsgdate"
        :edproc="dt.edproc"
        :dopstatused="dt.dopstatused"
        :solutioncode="dt.solutioncode"
        :pdf = "this.user?.ed_msg_enabled && dt.pdf"
        @showHistory="
          this.currentDT = dt;
          this.showHistory = true;
        "
      />
    </ul>
  </div>

</template>

<script>
  import ListDTRow from "@/components/ListDT/RowDT";
  import DTHistory from "@/components/DTHistory";
  import { mapState } from "vuex";

  
  export default {
    name: "ListDTItems",
    components: {
      ListDTRow,
      DTHistory,
    },
    data:() => ({
      showHistory: false,
      currentDT: {},
    }),
    computed: {
      ...mapState("ListDT", ["currentPageDT"]),
      ...mapState("Auth", ["user"]),
    },
  }
</script>